import React, { useState } from "react";
import DatePickerModal from "components/DatePickerModal";
import { DatePickerContainer, SearchBarDateInput } from "./style";
import { CalendarIcon } from "assets/icons";
import { Icon } from "components/Icon";
import moment from "moment";
import ReactDOM from 'react-dom';

type DatePicker = {
  label: string;
  dateRange: string[];
};

const StyledDatePicker: React.FC<DatePicker> = ({ label, dateRange }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <DatePickerContainer>
      <SearchBarDateInput
        onClick={() => {
          setOpenModal(true);
        }}
      >
        <label className="label-title">{label}</label>
        <div className="dateInputData">
        <input
          value={`${moment(dateRange[0]).format("MMM Do YYYY")} - ${moment(dateRange[1]).format("MMM Do YYYY")}`}
          //value={`${moment(dateRange[0]).format("ddd, MMM DD")} - ${moment(dateRange[1]).format("ddd, MMM DD")}`}
          readOnly
        />
        </div>
      </SearchBarDateInput>
      <Icon className="icon" width={30} height={30}>
        <CalendarIcon
          onClick={() => {
            setOpenModal(true);
          }}
        />
      </Icon>
      {/* Open DatePickerModal in document.body to prevent animation problems */}
      {openModal && ReactDOM.createPortal(
        <DatePickerModal openModal={openModal} setOpenModal={setOpenModal} />,
      document.body
      )}
    </DatePickerContainer>
  );
};

export default StyledDatePicker;
